import { useQuery } from '@tanstack/react-query';
import { httpGetModularWorkflowBuilderData } from 'services/backofficeIntegration/http/endpoints/modularWorkflow/httpGetModularWorkflowBuilderData';

export const useWorkflowBuilderData = (workflowId: number) =>
  useQuery({
    queryKey: httpGetModularWorkflowBuilderData.makeQueryKey(workflowId),
    queryFn: () => httpGetModularWorkflowBuilderData.callEndpoint(workflowId)
  });
